import { BaseEvent, eventRegistry } from "@Context/common/general/event-context";
import * as t from "io-ts";

export const TrainingPlansEventType = t.intersection([
  t.type({
    type: t.union([t.literal("open_drawer"), t.literal("show_toast"), t.literal("refresh_progress")]),
    timestamp: t.number,
  }),
  t.partial({
    message: t.string,
    title: t.string,
    isComplete: t.boolean,
    minimumLoadingMs: t.number,
  }),
]);

export type TrainingPlansEvent = t.TypeOf<typeof TrainingPlansEventType> & BaseEvent;

const trainingPlansEmitter = eventRegistry.registerEventType<typeof TrainingPlansEventType, TrainingPlansEvent>(
  "training-plans",
  TrainingPlansEventType
);

interface ITrainingPlansToastPayload {
  title: string;
  message: string;
  isComplete: boolean;
}

interface ITrainingPlansOpenDrawerPayload {
  minimumLoadingMs?: number;
}

export const trainingPlansEvents = {
  emitOpenDrawer: ({ minimumLoadingMs }: ITrainingPlansOpenDrawerPayload = {}) => {
    trainingPlansEmitter.emit({
      type: "open_drawer",
      minimumLoadingMs,
      timestamp: Date.now(),
    });
  },

  emitShowToast: ({ title, message, isComplete }: ITrainingPlansToastPayload) => {
    trainingPlansEmitter.emit({
      type: "show_toast",
      title,
      message,
      isComplete,
      timestamp: Date.now(),
    });
  },

  emitRefreshProgress: () => {
    trainingPlansEmitter.emit({
      type: "refresh_progress",
      timestamp: Date.now(),
    });
  },

  onTrainingPlansEvent: (callback: (event: TrainingPlansEvent) => void) => {
    return trainingPlansEmitter.on(callback);
  },

  onOpenDrawer: (callback: (payload: ITrainingPlansOpenDrawerPayload) => void) => {
    return trainingPlansEmitter.on(event => {
      if (event.type === "open_drawer") {
        callback({ minimumLoadingMs: event.minimumLoadingMs });
      }
    });
  },

  onShowToast: (callback: (payload: ITrainingPlansToastPayload) => void) => {
    return trainingPlansEmitter.on(event => {
      if (event.type === "show_toast" && event.title && event.message && typeof event.isComplete === "boolean") {
        callback({
          title: event.title,
          message: event.message,
          isComplete: event.isComplete,
        });
      }
    });
  },

  onRefreshProgress: (callback: () => void) => {
    return trainingPlansEmitter.on(event => {
      if (event.type === "refresh_progress") {
        callback();
      }
    });
  },
};
